import { diffLines } from 'diff'

const normalizeText = (value) => {
  return `${value ?? ''}`.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
}

export const buildSideBySideTextDiff = (baseText, compareText) => {
  const rows = []
  const changes = diffLines(
    normalizeText(baseText),
    normalizeText(compareText),
  ).map((change) => {
    const lines = change.value.split('\n')

    if (lines[lines.length - 1] === '') {
      lines.pop()
    }

    return {
      ...change,
      lines,
    }
  })

  let hasChanges = false
  let index = 0

  while (index < changes.length) {
    const change = changes[index]
    const currentIndex = index

    if (!change.lines.length) {
      index += 1
      continue
    }

    if (!change.added && !change.removed) {
      change.lines.forEach((line, lineIndex) => {
        rows.push({
          id: `unchanged-${currentIndex}-${lineIndex}`,
          leftText: line,
          leftTone: 'unchanged',
          rightText: line,
          rightTone: 'unchanged',
        })
      })
      index += 1
      continue
    }

    const nextChange = changes[index + 1]
    const isReplacementPair =
      Boolean(nextChange?.lines.length) &&
      ((change.removed && nextChange?.added) ||
        (change.added && nextChange?.removed))

    if (isReplacementPair) {
      const removedLines = change.removed ? change.lines : nextChange.lines
      const addedLines = change.added ? change.lines : nextChange.lines
      const rowCount = Math.max(removedLines.length, addedLines.length)
      hasChanges = hasChanges || rowCount > 0

      for (let lineIndex = 0; lineIndex < rowCount; lineIndex += 1) {
        rows.push({
          id: `changed-${index}-${lineIndex}`,
          leftText: removedLines[lineIndex] || '',
          leftTone: removedLines[lineIndex] ? 'removed' : 'empty',
          rightText: addedLines[lineIndex] || '',
          rightTone: addedLines[lineIndex] ? 'added' : 'empty',
        })
      }

      index += 2
      continue
    }

    hasChanges = hasChanges || change.lines.length > 0

    change.lines.forEach((line, lineIndex) => {
      rows.push({
        id: `${change.added ? 'added' : 'removed'}-${currentIndex}-${lineIndex}`,
        leftText: change.removed ? line : '',
        leftTone: change.removed ? 'removed' : 'empty',
        rightText: change.added ? line : '',
        rightTone: change.added ? 'added' : 'empty',
      })
    })

    index += 1
  }

  return {
    hasChanges,
    rows,
  }
}
